import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DownloadService } from '../../download/download.service';
import { Product, eItem, SessionItem, Stage, ProductsModel, WSRegMode, ProductPrice } from '../../shared';
import { StoreService } from '../../core';
import { HttpClient } from '@angular/common/http';
import { BaseFormation } from '../base-formation';
import { PathName, PathMode } from '../../shared/path.model';
import { EndWithSlash } from 'projects/lib-components/src/public_api';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'webstore-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})

export class ProductsComponent extends BaseFormation implements OnInit {
  hasResponsable: boolean = true;
  productsList: Product[];
  selectedProduct: Product;
  selectedProductStagesList: Stage[];
  catName: string;
  listPrices: ProductPrice[] = [];

  constructor(
    public store: StoreService,
    protected http: HttpClient,
    protected download: DownloadService,
    protected router: Router,
  ) { super(store); }

  ngOnInit(): void {
    this.store.showSplash(true);
    this.store.AppSettings.RegistrationMode = WSRegMode.INFO
    //this.store.begin.typeInscription = 'INFO-FORM';
    this.initData();
  }


  downloadDoc(): void {
    this.download.downloadFile(this.selectedProduct.PjextPRO);
  }

  selectProduct(page: string): void {
    super.setProduct(this.selectedProduct);

    if (page && page !== '') {
      if (this.selectedProductStagesList.length === 0)
        this.store.warning(this.store.getTrad('noproductstages'));
      else
        this.router.navigateByUrl(page);
    }
    else {
      const pg: string = this.store.begin.access === 'MIXED'
        ? this.store.AppRoutes.FORMMIXED
        : this.store.AppRoutes.FORMEXTRANET;
      this.router.navigateByUrl(pg);
    }
  }

  showProduct(product: Product): void {
    this.selectedProduct = product;
    this.selectedProductStagesList = product.ProductStagesList;
    this.store.PathItem.SetPathItem(PathName.PRODUCT, this.selectedProduct.Ident, this.selectedProduct);
    this.hasResponsable = this.store.PathItem.hasResponsable(PathMode.PRODUCT, this.selectedProduct.Ident);
    this.listPrices = this.selectedProduct.PricesList.filter((p: ProductPrice): boolean => p.Selected);
  }

  private initData(): void {
    const parentCategory: SessionItem|null = super.getSession(eItem.CATEGORY);
    if (parentCategory && parentCategory.id && parentCategory.id !== '') {
      this.catName = parentCategory.desc;

      const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/product/getData/V2/INITCAT/${parentCategory.id}`;
      this.http.get<ProductsModel>(destUrl).subscribe((data: ProductsModel): void => {
        if (!data.HasError) {
          if (data.ProductList.length === 0) {
            this.store.warning(this.store.getTrad('noproducts'));
          } else {
            this.productsList = data.ProductList;
            this.selectedProduct = this.productsList[0];
            this.selectedProductStagesList = this.selectedProduct.ProductStagesList;
            this.store.PathItem.SetPathItem(PathName.PRODUCT, this.selectedProduct.Ident, this.selectedProduct);
            this.hasResponsable = this.store.PathItem.hasResponsable(PathMode.PRODUCT, this.selectedProduct.Ident);
            this.listPrices = this.selectedProduct.PricesList.filter((p: ProductPrice): boolean => p.Selected);
          }
        }
        this.store.showSplash(false);
      }, (error: any): void => { JSON.stringify(error); });
    }
  }

  //////private setProductInfo(): void {
  //////  const destUrl: string = `${this.store.AppParams.apiUrl}/api/product/getData/INITPRO/${this.store.begin.productId}`;
  //////  this.http.get<ProductsModel>(destUrl).subscribe((data: ProductsModel) => {
  //////    if (!data.HasError) {

  //////      if (data.ProductList.length === 0) {
  //////        this.store.warning(this.store.getAlert('noproducts'));
  //////      } else {
  //////        this.catName = data.SelectedProduct.ParentCategory.Nom__CAT;
  //////        super.setCategory(data.SelectedProduct.ParentCategory);

  //////        this.productsList = data.ProductList;
  //////        this.selectedProduct = data.SelectedProduct;
  //////        this.selectedProductStagesList = this.selectedProduct.ProductStagesList;
  //////      }

  //////      this.store.begin.productId = '';
  //////      this.store.showSplash(false);

  //////    }
  //////  }, (error: any) => { JSON.stringify(error); });
  //////}
}
